import React from 'react';
import PanelAppearance from '../../containers/handoff/PanelAppearance';
import PanelBorder from '../../containers/handoff/PanelBorder';
import PanelCode from '../../containers/handoff/PanelCode';
import PanelProperties from '../../containers/handoff/PanelProperties';
import PanelShadows from '../../containers/handoff/PanelShadows';
import Fills from '../../containers/handoff/sidebar/Fills';
export default function HandoffShape() {
    return (React.createElement("div", null,
        React.createElement(PanelProperties, null),
        React.createElement(PanelAppearance, null),
        React.createElement(Fills, null),
        React.createElement(PanelBorder, null),
        React.createElement(PanelShadows, null),
        React.createElement(PanelCode, null)));
}
